// src/data/testimonials.js

import BalajiImg from "../assets/Balaji.png";
import DevaImg from "../assets/Deva.png";
import DivyaImg from "../assets/Divya.png";
import IrfanImg from "../assets/Irfan.png";
import MamathaImg from "../assets/mamatha.png";
import SowmyaImg from "../assets/Sowmya.png";

const testimonials = [
  {
    name: "Divya Sri",
    company: "Data Analyst Trainee",
    review: "Currently, I am pursuing my Data Analyst Internship here. The Institute has highly experienced faculty who not only guided me in shaping my career path but also helped me gain valuable knowledge across various courses. A truly supportive and enriching learning environment. I suggest everyone to take a good choice like mine.",
    image: DivyaImg,
    rating: 5,
  },
  {
    name: "Mamatha",
    company: "Full Stack Python Developer Intern",
    review: "I have undertaken an internship as a Full Stack Python Developer, gaining hands-on experience in front-end and back-end technologies. This role not only enhances my technical expertise but also allows me to contribute value to the institute through real-world project development.",
    image: MamathaImg,
    rating: 5,
  },
  {
    name: "Sai Sowmya",
    company: "Student",
    review: "This institute is very good for learning. Teachers explain topics clearly and are always helpful. The classes are easy to understand and interesting. The environment is friendly and supportive. Study materials are useful and well prepared. They guide students very well for improvement. I am happy with my experience and recommend this institute.",
    image: SowmyaImg,
    rating: 5,
  },
  {
    name: "Deva",
    company: "Web Development Trainee",
    review: "If you’re looking to start or advance your career in web development, this is the place. The trainers not only have experience but also provide explanations with plenty of practical examples. The interview training sessions held every Monday are unique and valuable. Best training with reasonable fees. Anyone can try this course here. Amazing institute to upgrade your skills for a future career.",
    image: DevaImg,
    rating: 5,
  },
  {
    name: "Balaji",
    company: "Data Analyst Trainee",
    review: "The Data Analyst program is very well-structured, starting from the basics of data handling to advanced tools and techniques. The curriculum covers essential skills like Excel, SQL, Python, data visualization, and real-time project work, which gave me a strong foundation for real-world applications.",
    image: BalajiImg,
    rating: 5,
  },
  {
    name: "Irfan",
    company: "Amazon",
    review: "Innovative Academy for IT Solutions is one of the best training institutes I’ve come across! The instructors are highly knowledgeable. The courses are well-structured and industry-relevant — covering everything from Python, Java, Web Development, Data Analytics, Tally, to MS Office and more. The learning environment is supportive, and the management is very professional. Highly recommend this place for anyone looking to build a strong IT career!",
    image: IrfanImg,
    rating: 5,
  },
];

export default testimonials;
